var map = {
	"./admin/reducer.js": 702,
	"./album/reducer.js": 703,
	"./announcement/reducer.js": 704,
	"./attendance/reducer.js": 705,
	"./class/reducer.js": 706,
	"./customer/reducer.js": 707,
	"./homework/reducer.js": 708,
	"./organization/reducer.js": 709,
	"./posts/reducer.js": 710,
	"./resource/reducer.js": 711,
	"./school/reducer.js": 903,
	"./serverTime/reducer.js": 712,
	"./sessions/reducer.js": 713,
	"./teacher/reducer.js": 714,
	"./user/reducer.js": 715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 701;